import ClassificationQuestionnairesList from "./ClassificationQuestionnairesList";

const ClassificationDetails = ({}) => {
    return(
        <>
          <ClassificationQuestionnairesList />
        </>
    )
}
export default ClassificationDetails;